/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import { ElementNode, } from 'lexical';
export function convertDetailsElement(domNode) {
    const isOpen = domNode.open !== undefined ? domNode.open : true;
    const node = $createCollapsibleContainerNode(isOpen);
    return {
        node,
    };
}
export class CollapsibleContainerNode extends ElementNode {
    constructor(open, key) {
        super(key);
        this.__open = open !== null && open !== void 0 ? open : false;
    }
    static getType() {
        return 'collapsible-container';
    }
    static clone(node) {
        return new CollapsibleContainerNode(node.__open, node.__key);
    }
    createDOM(_, editor) {
        const dom = document.createElement('details');
        dom.classList.add('Collapsible__container');
        dom.open = this.__open;
        dom.addEventListener('toggle', () => {
            const open = editor.getEditorState().read(() => this.getOpen());
            if (open !== dom.open) {
                editor.update(() => this.toggleOpen());
            }
        });
        return dom;
    }
    updateDOM(prevNode, dom) {
        if (prevNode.__open !== this.__open) {
            dom.open = this.__open;
        }
        return false;
    }
    static importDOM() {
        return {
            details: () => {
                return {
                    conversion: convertDetailsElement,
                    priority: 1,
                };
            },
        };
    }
    static importJSON(serializedNode) {
        const node = $createCollapsibleContainerNode(serializedNode.open);
        return node;
    }
    exportDOM() {
        const element = document.createElement('details');
        if (this.getLatest().__open) {
            element.setAttribute('open', '');
        }
        return { element };
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            type: 'collapsible-container',
            version: 1,
            open: this.__open,
        };
    }
    setOpen(open) {
        const writable = this.getWritable();
        writable.__open = open;
    }
    getOpen() {
        return this.__open;
    }
    toggleOpen() {
        this.setOpen(!this.getOpen());
    }
}
export function $createCollapsibleContainerNode(open) {
    return new CollapsibleContainerNode(open);
}
export function $isCollapsibleContainerNode(node) {
    return node instanceof CollapsibleContainerNode;
}
